import React from 'react';
import "../../../resources/RTCC/css/common/radio_box_style.css";
import { Label } from '../../atoms/RTCC/label';
import { LabelInputForm } from './labelInputForm';
import { PullDownOptionForm } from './pullDownOptionForm';

export const InputPassportList = (props) => {
    const { 
        representData,
        representFlgInfo,
        accompanyList,
        accompanyFlgList,
        yearListIssued,
        yearListValid,
        monthList,
        dayList,
        errorInfo,
        handleChangeRepresent,
        handleChangeAccompany,
    } = props;


    const represent =
        <div >
            <div style={styles.inputBlockRep}>
                <Label
                    label={"代表者"}
                    className={props.titleClassName}
                />
                <Label
                    label={"氏名"}
                    className={"grayLabel"}
                />
                <Label
                    label={representData.guestNameRoman}
                    className={"inputPassportLabel"}
                />
                <LabelInputForm
                    label={"パスポート番号"}
                    type={"text"}
                    id="passportNumber"
                    placeholder="XY1234567"
                    value={representData.passportNumber}
                    className={representFlgInfo.errPassportNum ? "inputKeywordErr" : "inputKeyword"}
                    onChange={() => handleChangeRepresent("passportNumber")}
                    labelClassName="grayLabel"
                    wrapClassName={representFlgInfo.errPassportNum ? "popupErrWrapLong" : "popupWrapLong"}
                />
                <Label label="発行年月日" className="grayLabel" />
                <div className="passportPullDownWrapper" >
                    <PullDownOptionForm
                        id="issueDay"
                        onChange={() => handleChangeRepresent("issueDay")}
                        wrapClassName="pullDownDay"
                        className={representFlgInfo.errIssueDate ? "passportpullModalButtonErr" : "passportpullModalButton"}
                        data={dayList}
                        state={representData.issueDay}
                    />
                    <PullDownOptionForm
                        id="issueMonth"
                        onChange={() => handleChangeRepresent("issueMonth")}
                        wrapClassName="pullDownMonth"
                        className={representFlgInfo.errIssueDate ? "passportpullModalButtonErr" : "passportpullModalButton"}
                        data={monthList}
                        state={representData.issueMonth}
                    />
                    <PullDownOptionForm
                        id="issueYear"
                        onChange={() => handleChangeRepresent("issueYear")}
                        wrapClassName="pullDownYear"
                        className={representFlgInfo.errIssueDate ? "passportpullModalButtonErr" : "passportpullModalButton"}
                        data={yearListIssued}
                        state={representData.issueYear}
                    />
                </div>
                <Label label="有効期間満了年月日" className="grayLabel" />
                <div className="passportPullDownWrapper" >
                    <PullDownOptionForm
                        id="validDay"
                        onChange={() => handleChangeRepresent("validDay")}
                        wrapClassName="pullDownDay"
                        className={representFlgInfo.errValidDate ? "passportpullModalButtonErr" : "passportpullModalButton"}
                        data={dayList}
                        state={representData.validDay}
                    />
                    <PullDownOptionForm
                        id="validMonth"
                        onChange={() => handleChangeRepresent("validMonth")}
                        wrapClassName="pullDownMonth"
                        className={representFlgInfo.errValidDate ? "passportpullModalButtonErr" : "passportpullModalButton"}
                        data={monthList}
                        state={representData.validMonth}
                    />
                    <PullDownOptionForm
                        id="validYear"
                        onChange={() => handleChangeRepresent("validYear")}
                        wrapClassName="pullDownYear"
                        className={representFlgInfo.errValidDate ? "passportpullModalButtonErr" : "passportpullModalButton"}
                        data={yearListValid}
                        state={representData.validYear}
                    />
                </div>
            </div>
        </div>;

    const accompany = accompanyList.map((value, index) =>
        <div key={"accompany" + index} >
            <div style={(accompanyList.length - 1) == index ? styles.inputBlockLast : styles.inputBlock}>
                <Label
                    label={"同行者" + (Number(index) + 1)}
                    className={props.titleClassName}
                />
                <Label
                    label={"(" + value.ageGroup + ")"}
                    className={props.titleClassName}
                />
                <Label
                    label={"氏名"}
                    className={"grayLabel"}
                />
                <Label
                    label={value.guestNameRoman}
                    className={"inputPassportLabel"}
                />
                <LabelInputForm
                    label={"パスポート番号"}
                    type={"text"}
                    id={"passportNumber" + index}
                    placeholder="XY1234567"
                    value={value.passportNumber}
                    className={accompanyFlgList[index] && accompanyFlgList[index].errPassportNum ? "inputKeywordErr" : "inputKeyword"}
                    onChange={() => handleChangeAccompany("passportNumber", index)}
                    labelClassName="grayLabel"
                    wrapClassName={accompanyFlgList[index] && accompanyFlgList[index].errPassportNum ? "popupErrWrapLong" : "popupWrapLong"}
                />
                <Label label="発行年月日" className="grayLabel" />
                <div className="passportPullDownWrapper" >
                    <PullDownOptionForm
                        id={"issueDay" + index}
                        onChange={() => handleChangeAccompany("issueDay", index)}
                        wrapClassName="pullDownDay"
                        className={accompanyFlgList[index] && accompanyFlgList[index].errIssueDate ? "passportpullModalButtonErr" : "passportpullModalButton"}
                        data={dayList}
                        state={value.issueDay}
                    />
                    <PullDownOptionForm
                        id={"issueMonth" + index}
                        onChange={() => handleChangeAccompany("issueMonth", index)}
                        wrapClassName="pullDownMonth"
                        className={accompanyFlgList[index] && accompanyFlgList[index].errIssueDate ? "passportpullModalButtonErr" : "passportpullModalButton"}
                        data={monthList}
                        state={value.issueMonth}
                    />
                    <PullDownOptionForm
                        id={"issueYear" + index}
                        onChange={() => handleChangeAccompany("issueYear", index)}
                        wrapClassName="pullDownYear"
                        className={accompanyFlgList[index] && accompanyFlgList[index].errIssueDate ? "passportpullModalButtonErr" : "passportpullModalButton"}
                        data={yearListIssued}
                        state={value.issueYear}
                    />
                </div>
                <Label label="有効期間満了年月日" className="grayLabel" />
                <div className="passportPullDownWrapper" >
                    <PullDownOptionForm
                        id={"validDay" + index}
                        onChange={() => handleChangeAccompany("validDay", index)}
                        wrapClassName="pullDownDay"
                        className={accompanyFlgList[index] && accompanyFlgList[index].errValidDate ? "passportpullModalButtonErr" : "passportpullModalButton"}
                        data={dayList}
                        state={value.validDay}
                    />
                    <PullDownOptionForm
                        id={"validMonth" + index}
                        onChange={() => handleChangeAccompany("validMonth", index)}
                        wrapClassName="pullDownMonth"
                        className={accompanyFlgList[index] && accompanyFlgList[index].errValidDate ? "passportpullModalButtonErr" : "passportpullModalButton"}
                        data={monthList}
                        state={value.validMonth}
                    />
                    <PullDownOptionForm
                        id={"validYear" + index}
                        onChange={() => handleChangeAccompany("validYear", index)}
                        wrapClassName="pullDownYear"
                        className={accompanyFlgList[index] && accompanyFlgList[index].errValidDate ? "passportpullModalButtonErr" : "passportpullModalButton"}
                        data={yearListValid}
                        state={value.validYear}
                    />
                </div>
            </div>
        </div>
    );

    return (
        <div className="inputPassportWrapper">
            {represent}
            {accompany}
        </div>
    );
}

const styles = {
    inputBlockRep: {
        display: "block",
        flexWrap: "wrap",
        padding: "20px 0px 20px 0px",
    },
    inputBlock: {
        display: "block",
        flexWrap: "wrap",
        padding: "30px 0px 20px 0px",
        borderTop: "1px solid rgb(191, 190, 197)",
    },
    inputBlockLast: {
        display: "block",
        flexWrap: "wrap",
        padding: "30px 0px 0px 0px",
        borderTop: "1px solid rgb(191, 190, 197)",
    },
}